import { formatStatus } from '../format';
import type { ProjectStatus } from '../types';

const STATUS_CHIP_CLASS_NAMES: Record<ProjectStatus, string> = {
  draft: 'bg-neutral-100 text-neutral-600',
  in_progress: 'bg-green-100 text-green-700',
  completed: 'bg-amber-100 text-amber-700',
  archived: 'bg-neutral-200 text-neutral-500',
};

export function ProjectStatusChip({ status }: { status: ProjectStatus }) {
  return (
    <span
      className={`inline-flex rounded-full px-2.5 py-1 text-small font-medium capitalize ${STATUS_CHIP_CLASS_NAMES[status]}`}
    >
      {formatStatus(status)}
    </span>
  );
}

export function ProjectDeletedChip() {
  return (
    <span className="inline-flex rounded-full bg-red-50 px-2.5 py-1 text-small font-medium text-red-700">
      Deleted
    </span>
  );
}
